import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const LinkedAppointmentInfo = (_param)=> {
    var { className , labels , linkedAppointmentCtaUrl , alternativeAppointmentCtaUrl , linkedAppointmentTypeIdIsAvailable , alternativeAppointmentTypeIdIsAvailable  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "linkedAppointmentCtaUrl",
        "alternativeAppointmentCtaUrl",
        "linkedAppointmentTypeIdIsAvailable",
        "alternativeAppointmentTypeIdIsAvailable"
    ]);
    return React.createElement("div", swcHelpers.extends({
        className: classnames('linked-appointment-info', className)
    }, rest), /*#__PURE__*/ React.createElement(Icon, {
        name: "child-appointment"
    }), /*#__PURE__*/ React.createElement("p", {
        className: "typography-text typography-text--caption linked-appointment-info__text"
    }, linkedAppointmentTypeIdIsAvailable && linkedAppointmentCtaUrl && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
        className: "linked-appointment-info__title"
    }, labels.linkedAppointmentTitle), /*#__PURE__*/ React.createElement("a", {
        className: "linked-appointment-info__cta",
        href: linkedAppointmentCtaUrl
    }, labels.linkedAppointmentCta)), alternativeAppointmentTypeIdIsAvailable && alternativeAppointmentCtaUrl && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
        className: "linked-appointment-info__title"
    }, labels.alternativeAppointmentTitle), /*#__PURE__*/ React.createElement("a", {
        className: "linked-appointment-info__cta",
        href: alternativeAppointmentCtaUrl
    }, labels.alternativeAppointmentCta))));
};

export { LinkedAppointmentInfo as default };
//# sourceMappingURL=LinkedAppointmentInfo.js.map
